import { render, staticRenderFns } from "./ModuleBox.vue?vue&type=template&id=34fc5094"
import script from "./ModuleBox.vue?vue&type=script&lang=js"
export * from "./ModuleBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports